import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: 'sm-add-reply-for-service-query',
  templateUrl: './add-reply-for-service-query.component.html',
  styleUrls: ['./add-reply-for-service-query.component.scss']
})
export class AddReplyForServiceQueryComponent implements OnInit {
  reply: any;
  apisub: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private apiservice: ApiService,
    private loader: LoaderServiceService,
    private activemodal: MatDialogRef<AddReplyForServiceQueryComponent>
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_ENROLL_STATUS
      ) {
        if (resdata.result) {
          this.activemodal.close({ msg: "success" });
        }
      }
    });
  }

  ngOnInit(): void {}

  onPost() {
    this.activemodal.close({reply: this.reply})
  }
}
